import React from "react";
// STYLES
import notFoundImage from "../../assets/error/404.png";

function NotFoundPage() {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <div className="generalStyles__flexCenter mb-5">
        <img src={notFoundImage} alt="" width="300" />
      </div>
    </div>
  );
}

export default NotFoundPage;
